import { render } from "./Dialog.vue?vue&type=template&id=3596b826"
import script from "./Dialog.vue?vue&type=script&lang=ts"
export * from "./Dialog.vue?vue&type=script&lang=ts"
script.render = render

export default script